module.exports = "/images/vendor/greenmotion-shared/svgs/cards/MasterCard.svg?3e1afaa2c906b4670028b8513be26b2b";